<div class="recommendation-card">
  <div class="card-content">
    <div class="card-title-row">
      <span class="ai-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 7L14.5 5.5L16 5L14.5 4.5L14 3L13.5 4.5L12 5L13.5 5.5L14 7Z" fill="#070C31"/>
          <path d="M12 14L14 9L16 14L21 16L16 18L14 23L12 18L7 16L12 14Z" fill="#070C31"/>
        </svg>
      </span>
      <h3 class="card-title">{{ recommendation.title }}</h3>
    </div>
    <p class="card-description">{{ recommendation.description }}</p>
  </div>
  <div class="card-footer">
    <span class="priority-badge" [ngClass]="priorityClass">{{ priorityLabel }}</span>
    <button type="button" class="action-link" (click)="onActionClick()">
      <span>{{ recommendation.actionLabel }}</span>
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.25 12.75L10.75 8.5L6.25 4.25" stroke="#131313" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>
